const smartMixins = {
  data() {
    return {
      formItemLayout: {
        labelCol: { lg: { span: 4 }, sm: { span: 8 } },
        wrapperCol: { lg: { span: 20 }, sm: { span: 16 } }
      },
      searchItemLayout: {
        labelCol: {
          span: 9
        },
        wrapperCol: {
          span: 15
        }
      },
      queryParams: {},
      columns: [
        {
          title: 'ID',
          dataIndex: 'memberId'
        },
        {
          title: '昵称',
          dataIndex: 'nickName'
        },
        {
          title: '手机号',
          dataIndex: 'mobileNo'
        },
        {
          title: '累计订单',
          dataIndex: 'totalOrderNum'
        },
        {
          title: '累计消费金额（元）',
          dataIndex: 'totalAmount'
        },
        {
          title: '来源',
          dataIndex: 'source'
        },
        {
          title: '最近访问',
          dataIndex: 'lastLoginTimeStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '90px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    const list = [
      { name: 'DeviceManager', title: '设备管理' },
      { name: 'ChannelManager', title: '渠道管理' },
      { name: 'OrderManager', title: '订单管理' }
      // {name:"Statistics", title:"数据统计"},
    ]
    this.$store.commit('SET_MENU_HEAD_CONFIG', list)
  },
  methods: {
    getUserList(params) {
      return this.getHttpServices().getUserService().get('api/v2/member/list', params)
    }
  }
}
export default smartMixins
